import { NodeSubType } from "../models/nodeSubType";

export enum ParentBlockType {
  MESSAGE = "Message",
  ACTION = "Action",
  AI = "AI",
}

/**
 * Maps legacy/alias ?feature= param values to their actual sidebar blockId.
 */
const FEATURE_ALIAS_MAP: Partial<Record<string, NodeSubType>> = {
  // "send_email" is an old id; the sidebar block uses EMAIL_TEMP_NEW
  send_email: NodeSubType.EMAIL_TEMP_NEW,
  // The legacy inline-config AI agent block is deprecated; the dashboard's
  // recommendation still sends "ai_agent", which now means the agentic builder block.
  [NodeSubType.AI_AGENT]: NodeSubType.AGENTIC_BUILDER,
};

export const normalizeFeatureBlockId = (featureBlockId: string): string => {
  return FEATURE_ALIAS_MAP[featureBlockId] ?? featureBlockId;
};

/**
 * Maps a feature blockId to its parent block type category
 * @param featureBlockId - The block ID from the feature parameter
 * @returns The parent type ("Message", "Action", "AI", or "Condition") or null if not found
 */
export const getParentTypeForFeature = (featureBlockId: string): ParentBlockType | null => {
  // Message blocks
  const messageBlocks = [
    NodeSubType.EMAIL_TEMP_NEW,
  ];

  // Action blocks
  const actionBlocks = [
    NodeSubType.DISCOUNT_CODE,
  ];

  // AI blocks
  const aiBlocks = [
    NodeSubType.AGENTIC_BUILDER,
  ];

  if (messageBlocks.includes(featureBlockId as NodeSubType)) {
    return ParentBlockType.MESSAGE;
  } else if (actionBlocks.includes(featureBlockId as NodeSubType)) {
    return ParentBlockType.ACTION;
  } else if (aiBlocks.includes(featureBlockId as NodeSubType)) {
    return ParentBlockType.AI;
  }

  return null;
};
